import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 港前、尾程运价查询
export function queryPrePortLastMilePrice(data) {
  return request({
    url: URL.price.queryPrePortLastMilePrice,
    method: 'post',
    data
  })
}
// 港前、尾程运价详情
export function prePortLastMilePriceDetail(data) {
  return request({
    url: URL.price.prePortLastMilePriceDetail,
    method: 'post',
    data
  })
}
// 港前、尾程运价保存
export function savePrePortLastMilePrice(data) {
  return request({
    url: URL.price.savePrePortLastMilePrice,
    method: 'post',
    data
  })
}
// 港前、尾程运价复制
export function copyPrePortLastMilePrice(data) {
  return request({
    url: URL.price.copyPrePortLastMilePrice,
    method: 'post',
    data
  })
}
// 港前、尾程运价编辑状态
export function editPrePortLastMilePriceStatus(data) {
  return request({
    url: URL.price.editPrePortLastMilePriceStatus,
    method: 'post',
    data
  })
}
